import { render } from "./DonationStoreFormView.vue?vue&type=template&id=9b4b497c&scoped=true"
import script from "./DonationStoreFormView.vue?vue&type=script&lang=js"
export * from "./DonationStoreFormView.vue?vue&type=script&lang=js"

import "./DonationStoreFormView.vue?vue&type=style&index=0&id=9b4b497c&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b4b497c"]])

export default __exports__